import cipher3Hint1 from '../../../../assets/images/games/zdar-escape-game/ciphers/3/hint1.webp';
import cipher3Hint2 from '../../../../assets/images/games/zdar-escape-game/ciphers/3/hint2.webp';
import track3 from '../../../../assets/audio/tracks/track3.mp3';

const hints = [
    {
        image: cipher3Hint1,
    },
    {
        image: cipher3Hint2,
    },
];
export const step3well = {
    id: 3,
    title: '1. stanoviště',
    taskText: `
        <p>
            Uff tak to byla práce. Slyšíš, ještě něco volá. Cože? Máme spočítat všechny celé čtverce na mřížce a potom udělat stejný počet kroků na 146° jihovýchodně.
        </p>
        <p>
            Ty jo, tak to nemůže říct rovnou. Jo a ještě říkal, že máme po cestě sledovat ptáky. Že prý má pocit, že by bylo dobré si je pořádně zapsat za uši.
        </p>
        <p>
            Pravda je, že ptáci mají vždycky přehled, dokonce větší než já. Ty jo, co to bylo na tom morovém sloupu nahoře? Jo už vím, ještě že ty ptáky ve Žďáře tak dobře znám. Hned si to radši zapamatuji, kdybych jen mohl, tak si to i zapíšu.
        </p>
    `,
    catImage: 1,
    cipher: {
        text: 'Spočítejte všechny celé čtverce na mřížce a potom udělejte stejný počet kroků na 146° jihovýchodně. Až budete na místě, klikněte na zelené tlačítko níže.',
        label: 'Úkol',
    },
    taskPreviewText:
        'Uff tak to byla práce. Slyšíš, ještě něco volá. Cože? Máme spočítat všechny celé čtverce na mřížce a potom udělat stejný počet kroků',
    audio: track3,
    snowAudio: track3,
    hints: hints,
    snowHints: hints,
    continueButtonText: 'Jsme na místě',
};
